import React from 'react';
import styles from "./DomainTaskTitleComponent.module.css"


  export const DomainTaskTitle: React.FunctionComponent = () => {
    return (
    <>
      <div className={styles.domainTaskHeaderBlock}>
        <p className={styles.domainTaskHeader}>What Is This Task & Why Is It Important?</p>
      </div>
    </>  
    );
  };